var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redes-view"},[_c('ServiceNavbar'),_c('ContactanoWien'),_c('UbicacionSection'),_c('JeanInformaticaEmpresa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }